import { styled } from "styled-components";

import { MD_WIDTH } from "styles/theme/layout";

export const EmailWrapper = styled.div`
  display: flex;
  border-radius: 4px;
  border: 0.5px solid #4a5a93;
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;

  @media (min-width: ${MD_WIDTH}px) {
    width: 360px;
  }
`;

export const EmailInput = styled.input`
  outline: none;
  color: #747474;
  border-radius: 4px;
  ${({ theme }) => theme.typography.bodyText["b6reg"]}
`;

export const SubmitButton = styled.button`
  color: #d9d9d9;
`;
